import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';

import {generateVideo,deleteVideo, type GenerateVideoRequest, type GenerateVideoResponse} from '@/api/videos'

import { queryKeys } from '@/lib/queryKeys';

export function useGenerateVideoMutation(
    options?: UseMutationOptions<GenerateVideoResponse, Error, GenerateVideoRequest>,
    ) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: generateVideo,
        onSuccess: () => {
        queryClient.invalidateQueries({
            queryKey: queryKeys.videos.history(),
        });
        },
        ...options,
    });
}

export function useDeleteVideoMutation(
    options?: UseMutationOptions<void, Error, string>,
    ) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteVideo,
        onSuccess: () => {
        queryClient.invalidateQueries({
            queryKey: queryKeys.videos.history(),
        });
        },
        ...options,
    });
}